const DB = "observer";
const STORE = "chunks";
let dbp;

function db() {
  if (!dbp) {
    dbp = new Promise((resolve, reject) => {
      const r = indexedDB.open(DB, 1);
      r.onupgradeneeded = () => r.result.createObjectStore(STORE, { keyPath: "key" }).createIndex("sid", "sid");
      r.onsuccess = () => resolve(r.result);
      r.onerror = () => reject(r.error);
    });
  }
  return dbp;
}

async function run(mode, fn) {
  const d = await db();
  return new Promise((resolve, reject) => {
    const t = d.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(req?.result);
    t.onerror = () => reject(t.error);
  });
}

export const putChunk = (c) => run("readwrite", (s) => s.put(c));
export const deleteChunk = (key) => run("readwrite", (s) => s.delete(key));
export const listChunks = (sid) => run("readonly", (s) => s.index("sid").getAll(sid));

const cacheKey = (sid) => `observer.cache.${sid}`;

export function readCache(sid) {
  try {
    return JSON.parse(localStorage.getItem(cacheKey(sid)) || "null");
  } catch {
    return null;
  }
}

export function writeCache(sid, data) {
  try {
    localStorage.setItem(cacheKey(sid), JSON.stringify(data));
  } catch {
    /* quota exceeded: cache is best-effort */
  }
}

export const clearCache = (sid) => localStorage.removeItem(cacheKey(sid));
